import { useDialog } from "lib/@hooks/useDialog"
import { busyWhile } from "lib/@components/busy/busy-while"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { navigate } from "lib/routes/navigate"
import { createRuleSet } from "routes/rule-sets/controller/create-rule-set"
import { CreateRuleSetDialog } from "./create-rule-set-dialog"
import { saveRuleSetContext } from "./rule-set-context-storage"

export function useCreateRuleSet() {
    const openDialog = useDialog(<CreateRuleSetDialog />, { maxWidth: "sm", fullWidth: true })

    return handleCreate

    async function handleCreate() {
        const result = await openDialog()
        if (!result) return
        const defaultAction = result.includeByDefault === false ? "exclude" : "include"
        const newSet = await busyWhile(
            () =>
                createRuleSet({
                    name: result.name,
                    description: result.description,
                    defaultAction,
                }),
            "Creating rule set..."
        )
        if (!newSet?.id) return

        // Persist the regime + asset register selections locally, keyed by rule set id.
        saveRuleSetContext(newSet.id, {
            regime: result.regime || null,
            assetRegister: result.assetRegister || null,
        })

        navigate(`/app/optimiser/rule-sets/${newSet.id}`)
        successSnackbar("Rule Set Created Successfully")
    }
}
